module.exports = {"230123100":"依兰镇","230123101":"达连河镇","230123102":"江湾镇","230123103":"三道岗镇","230123104":"道台桥镇","230123105":"宏克利镇","230123200":"团山子乡","230123201":"愚公乡","230123202":"迎兰朝鲜族乡","230123400":"依兰县林业局","230123500":"依兰农场","230123501":"松花江农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230123.json
// module id = 770
// module chunks = 0